<template>
  <div>
    <v-data-table
      hide-default-footer
      :headers="question.Headers"
      :items="question.Value"
    >
      <!--
        item is a Vuetify dynamic slot which controls the rendering of certain columns (by name)
        to target a column by name use the Headers array value property (see renderAPI.json)
        Vuetify also provides a destructured 'item' variable (not used here)
        the item variable contains the individual row (object) data
      -->
      <template v-slot:item.PreviousClaimAmountOfLoss.Value="{ item }">
        {{
          item.PreviousClaimAmountOfLoss.Value
            | formatCurrency(AMOUNT_DEFAULT_FORMAT)
        }}
      </template>
      <template v-slot:[`item.actions`]="{ index }">
        <v-icon small color="var(--red-500)" size="16">
          mdi-minus-circle </v-icon
        ><a
          href="#"
          class="d-inline-flex align-center text-uppercase font-weight-regular ml-2"
          @click.prevent="deleteRow(index)"
          >remove</a
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { AMOUNT_DEFAULT_FORMAT } from "@/constants/currency-format.constants";
export default {
  name: "TableBase",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      AMOUNT_DEFAULT_FORMAT: AMOUNT_DEFAULT_FORMAT,
    };
  },
  methods: {
    // this function removes a table row
    // here we don't have an id to target on the question.Value array
    // so instead we pass in the table row index number
    deleteRow(rowIndex) {
      this.question.Value = this.question.Value.filter((item, index) => {
        return index !== rowIndex;
      });
      if (this.question.Value.length === 0) {
        this.question.Questions.forEach((item) => {
          item.Validation.Rules.push("ruleRequired");
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
